import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VListItem,[_c(VListItemContent,[_c(VListItemSubtitle,[_vm._v(_vm._s(_vm.$t('labels.firm')))]),(_vm.firm)?_c(VListItemTitle,[_vm._v(_vm._s(_vm.firm.display))]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }